import { UtmInfo } from "atoms/models";
import { getBaseUrl, getRequestWithTokenInformation } from "./common";
import { RequestInit } from "atoms/models";

export const getEcommerceShop = async (token: string | null, item: string | null, type: string | null, utmInfo: UtmInfo | null) => {
  if (null === token) {
    return null;
  }
  const baseUrl = getBaseUrl();
  const relativeUrl = "ecommerce/route/customerAuth";

  let requestParams = "";
  if (item && type) {
    requestParams = `?item=${item}&type=${type}`;

    if (utmInfo) {
      requestParams += `&utm_content=${utmInfo.content}&utm_medium=${utmInfo.medium}&utm_source=${utmInfo.source}&utm_campaign=${utmInfo.campaign}`;
    }
  }

  const input = new URL(relativeUrl + requestParams, baseUrl).href;
  const headers = new Headers();
  headers.append("Authorization", `Bearer ${token}`);
  const init: RequestInit = getRequestWithTokenInformation("GET", headers);
  const response = await window.fetch(input, init);
  const json = await response.json();
  return json;
};
